<h5>{{ 'STEP4.question' | translate  }}</h5>
<app-numeric-up-down [(value)]="quotation.printers"></app-numeric-up-down>
<i class="question" [innerHTML]="'STEP4.description' | translate"></i>
